import React, { Fragment, useEffect, useState } from 'react';
import { useOktaAuth, LoginCallback as LCB } from '@okta/okta-react';
import OktaAuthenticationError from './OktaAuthenticationError';
import Loader from '../../atoms/Loader';
import TimeZoneMismatch from '../../atoms/TimeZoneMismatch';
import UnassignedTapApps from '../../atoms/UnassignedTapApps';
import DefaultOktaError from '../../atoms/DefaultOktaError';
import { OKTA_ERRORS } from '../../constants/Constants';
const LoginCallback = _ref => {
  let {
    setupUrl = '/app/setup'
  } = _ref;
  const {
    oktaAuth,
    authState
  } = useOktaAuth();
  const [isRenderComponent, setIsRenderComponent] = useState(true);
  const authStateReady = authState === null || authState === void 0 ? void 0 : authState.isAuthenticated;
  useEffect(() => {
    // if (!authState || !authState.isAuthenticated) {
    //   setIsAuthenticated(false);
    // } else {
    //   setIsAuthenticated(true);
    // }
    const redirectUri = "".concat(window.location.origin, "/app/callback");
    oktaAuth.handleRedirect(redirectUri);
  }, [oktaAuth]); // Update if authState changes

  const handleOktaErrors = props => {
    const {
      error
    } = props;
    if (error) {
      setIsRenderComponent(false);
      const {
        errorSummary
      } = error;
      if (errorSummary === OKTA_ERRORS.JWT_ISSUED_IN_FUTURE || errorSummary === OKTA_ERRORS.JWT_EXPIRED) {
        return /*#__PURE__*/React.createElement(TimeZoneMismatch, null);
      }
      if (errorSummary === OKTA_ERRORS.USER_NOT_ASSIGNED_TO_APP) {
        return /*#__PURE__*/React.createElement(UnassignedTapApps, null);
      }
    }
    return /*#__PURE__*/React.createElement(DefaultOktaError, null);
  };
  const renderComponent = () => {
    let ComponentWrapper = /*#__PURE__*/React.createElement(Loader, {
      id: "tap-login-callback-loader",
      top: "0"
    });
    if (authStateReady && authState !== null && authState !== void 0 && authState.error) {
      ComponentWrapper = /*#__PURE__*/React.createElement(OktaAuthenticationError, {
        error: authState.error
      });
    } else if (authStateReady) {
      window.location.href = setupUrl;
    }
    return ComponentWrapper;
  };
  return /*#__PURE__*/React.createElement(Fragment, null, isRenderComponent && renderComponent(), /*#__PURE__*/React.createElement(LCB, {
    errorComponent: handleOktaErrors
  }));
};
export default LoginCallback;